<template>
  <div>
    <div class="d-flex align-items-center">
      <div style="background: #CFAD6C;border-radius: 50px;width: 9px; height: 2px;margin-left: 1px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-left: 3px"></div>
      <div class="headerStyle">ارسال به</div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 27px; height: 2px;margin-right: 3px"></div>
      <div style="background: #CFAD6C;border-radius: 50px;width: 2px; height: 2px;margin-right: 1px"></div>
    </div>
    <p class="w-100">{{shippingData.buyer.addressText}}</p>
  </div>
</template>

<script>
export default {
  props: {
    shippingData: {
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.headerStyle {
  color: #414141;
  font-size: 18px;
}

@media only screen and (max-width: 768px) {
  .headerStyle {
    font-size: 16px;
  }
}
@media only screen and (max-width: 576px) {
  .headerStyle {
    font-size: 14px;
  }
}
</style>
